<template>
  <div class="wrapper">
    <p  class="request-token-title">{{ this.title }}</p>

    <div class="content main-error">
      <div v-for="(error, index) in getResponseErrors" :key="index">
        <div class="generalErr" v-if="error.general_error && submitted">
          <span class="error-value">{{ error.message }}</span>
        </div>
      </div>
      <div class="generalErr" v-if="submitted && getResponseErrors && getResponseErrors.message">
        <span class="error-value">{{ getResponseErrors.message }}</span>
      </div>
      <div v-for="(el, index) in external_scenario_fields" :key="index">
        <InputSettings :element="el" :index="index" :submitted="submitted" :errors="getResponseErrors"
          :getReAuth="getReAuth" />
      </div>
    </div>
    <!-- action btns  -->
    <hr class="vertical-line" />
    <div class="modal-actions-btns">
      <VpButton :text="$t('integrations.request')" :disabled="getLoading || external_scenario_fields.find(item => !item.value && item.validation.required)" :isLoading="getLoading" @click="onSubmit()" />
      <VpButton :text="$t('common.cancel')" :width="getReAuth ? '130px' : '112px'" :isDanger="true" @click="$bvModal.hide('extraScenario')" />
    </div>
  </div>
</template>
  
<script>
import InputSettings from "./InputSettings";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    InputSettings,
  },
  data: () => ({
    submitted: false,
    external_scenario_fields: [],
    errors: {},
    dir_extra_scenario: {},
    hasErrors: false,
    configData: [],
    title: "",
  }),

  methods: {
    ...mapActions("integration", [
      "preRequest"
    ]),

    onSubmit() {
      this.submitted = true;

      const formBody = {}
      this.external_scenario_fields.forEach((item) => {
        if (!item.value && item.validation.required) {
          this.hasErrors = true
        }
        formBody[item.key_code] = item.value
      })
      console.log(formBody)
      console.log('has errors', this.hasErrors)
      if (!this.hasErrors) {
        const payload = {
          request_url: this.dir_extra_scenario.request_url,
          code: this.dir_extra_scenario.code,
          action_type: this.dir_extra_scenario.action_type,
          entity_id: this.currentEntity.id,
          created_by: this.userDetails.id,
          body: formBody
        }
        this.preRequest(payload).then(() => {
          this.$bvModal.hide("extraScenario")
        })
      }
      this.hasErrors = false
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("integration", [
      "getLoading",
      "getModalState",
      "getResponseErrors",
      "getReAuth",
    ]),
    ...mapGetters("authfack", ["currentEntity", "userDetails"]),
  },
  watch: {
    getModalState(state) {
      console.log('watch', state);
      state == true && this.$bvModal.hide("extraScenario");
    },
  },
  mounted() { },
  beforeMount() {
    const { dir_extra_senario } = this.getModalInfo;
    this.dir_extra_scenario = dir_extra_senario[0]
    const formBody = JSON.parse(dir_extra_senario[0].form_body)
    this.title = formBody.form_label
    const { form_fields } = formBody
    this.external_scenario_fields = form_fields.map((item) => {
      return {
        key_code: item.id,
        originalValue: null,
        value: null,
        is_invalid: 0,
        editable: 0,
        name: item.name,
        id: item.id,
        validation: item.validation
      };
    });
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/modal.scss';
</style>
  